// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiUrl: 'http://localhost:8083',
  downloadURL: 'http://localhost:8083/document/downloadfile?',
  downloadZipURL: 'http://localhost:8083/document/downloadzipfile?',
  downloadZipCalendarNewsURL: 'http://localhost:8083/document/downloadzipcalendarnewsfile?',
  socketUrl: 'http://localhost:8080/ws',
  chatReceiveUrl: '/egovws/chatreceive/',
  chatSendUrl: '/egovapp/chat.send.',
  chatAddUrl: '/egovapp/chat.add.',
  exportToTrinh: 'http://localhost:2728/totrinh/export/',
  printToTrinh: 'http://localhost:2728/totrinh/print/',
  exportYeuCau: 'http://localhost:2728/yeucau/export/',
  printYeuCau: 'http://localhost:2728/yeucau/print/',
  exportThongBao: 'http://localhost:2728/thongbao/export/',
  printThongBao: 'http://localhost:2728/thongbao/print/',
  exportMeeting: 'http://localhost:2728/meeting/export/',
  printMeeting: 'http://localhost:2728/meeting/print/',
  printVBDSoCongVan: 'http://localhost:2728/vanbanden/insocv?',
  printVBDiSoCongVan: 'http://localhost:2728/vanbandi/insocv?',
  exportLichCongTac: 'http://localhost:2728/calendarnews/export',
  exportDSLichCongTac: 'http://localhost:2728/calendarnews/exportds',
  printLichCongTac: 'http://localhost:2728/calendarnews/print',
  exportLichDonVi: 'http://localhost:2728/calendardepart/export',
  exportDSLichDonVi: 'http://localhost:2728/calendardepart/exportds',
  printDonVi: 'http://localhost:2728/calendardepart/print',
  pageMaxRecord: 10,
  currentPage: 1,
  numberPages: 0,
  soanthao: 0,
  chuaxuly:  1,
  dangxuly:  2,
  hoanthanh: 3,
  khongxuly: 4,
  phocap:  6,
  guidichdanh: 7,
  tralaivanthu: 8,
  chogiaoxuly: 9,
  hosocanhan: 2,
  hosodonvi: 9,
  hosophocap: 10,
  daphatbieu: 2,
  chuaphatbieu: 1,
  configToolbar: { toolbar: [ 'heading', '|', 'bold', 'italic', 'Undo', 'Redo' ,
       'bulletedList', 'numberedList', 'blockQuote', 'Link', 'Unlink', 'Anchor'
    ] },
  apButPheVanBanDen: true,
  view: 'VIEW',
  viewall: 'VIEWALL',
  add: 'ADD',
  update: 'UPDATE',
  delete: 'DELETE',
  approved: 'APPROVED',
  download: 'DOWNLOAD',
  detail: 'DETAIL',
  ykien: 'COMMENT',
  share: 'SHARE',
  ykientonghop: 'COMMENTSUM',
  viewhistory: 'VIEWHISTORY',
  chenhoso: 'INSERTDOCUMENT',
  uploadfileykien: 'UPLOADCOMMENT',
  taifilecomment: 'DOWNLOADCOMMENT',
  chuyentrinh: 'TRANSACTION',
  chuyengiaoviec: 'ASSIGNWORK',
  butphe: 'HEADER',
  giaoxuly: 'ASSIGN',
  giaocapduoi: 'ASSIGNNEXT',
  xuly: 'HANDLE',
  actionphocap: 'PUBLIC',
  actionbophocap: 'PRIVATE',
  insocongvan: 'PRINTCV',
  capnhatso: 'UPDATESVT',
  giaothem: 'ASSIGNADD',
  thayfile: 'REPLACEFILE',
  suathoihan: 'UPDATEEXPRIED',
  xulylai: 'HANDLEREPEATE',
  chuyenhoanthanh: 'CHANGESTATUS',
  xemtatca: 'VIEWALL',
  chophepthamkhao: 'ACCEPTCOMMENT',
  ykienrieng: 'COMMENTPRIVATE',
  xemfile: 'VIEWFILE',
  docvanban: 'READDOCUMENT',
  docthongbao: 'READ',
  toanquyen: 'FULLPERMISSION',
  themnguoinhan: 'ADDPERSON',
  xemkhac: 'VIEWOTHER',
  thumucluutru: 'SAVEDIR,',
  print: 'PRINT',
  logo_width_lagre: 50,
  logo_height_lagre: 50,
  logo_width_small: 50,
  logo_height_small: 50,
  yearNext: 10,
  VBTYPE_BENDANG: 'VBDANG',
  VBTYPE_BENCHINHQUYEN: 'VBCHINHQUYEN',
  SEARCH_TUONGDOI: 1,
  SEARCH_CHINHXAC: 0,
  SEARCH_ALL: 'ALL',
  VANBANDEN: 'VANBANDEN',
  VANBANDI: 'VANBANDI',
  TOTRINH: 'TOTRINH',
  YEUCAU: 'YEUCAU',
  CALENDARNEWS: 'CALENDARNEWS',
  CALENDARDEPART: 'CALENDARDEPART',
  HOSO: 'HOSO',
  THONGBAO: 'THONGBAO',
  MEETING: 'MEETING'


};
